import { render, staticRenderFns } from "./VisaSingle.vue?vue&type=template&id=40fb6d24&scoped=true&"
import script from "./VisaSingle.vue?vue&type=script&lang=js&"
export * from "./VisaSingle.vue?vue&type=script&lang=js&"
import style0 from "./VisaSingle.vue?vue&type=style&index=0&id=40fb6d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40fb6d24",
  null
  
)

export default component.exports